/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-05-16 11:51:33
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyUtils } from '../../utils/Utils';
import BsyTextEditor from '../BsyTextEditor';
import BsyTextTag from '../BsyTextTag';
import { BsyWidget } from '../BsyWidget';
import './index.css'

class BsyRadioBox extends BsyWidget {

    static defaultProps = {
        text: '',
        value: false,
    }
    constructor(props) {
        super({
            baseCls: 'BsyCheckBox',
            ...props
        })
        this.state = {
            text: this.options.text,
            value: this.options.value,
        }
    }

    setValue = (value) => {
        this.setState({
            value: value ? true : false,
        })
    }
    getValue = (value) => {
        return this.state.value;
    }
    checkChange = (val) => {
        return (event) => {
            event.stopPropagation();
            event.preventDefault();
            this.setState({
                value: val
            }, () => {
                if (this.props.onChange) {
                    this.props.onChange(val)
                } else if (this.props.onStopEdit) {
                    this.props.onStopEdit(val)
                }

            })

        }
    }
    render() {
        const { text, value } = this.state;
        const { cssName } = this.options;
        return (
            <div className={cssName}
                onClick={this.checkChange(!value)}
                ref={this.element}
            >
                {
                    <div className={"x-radio data-label-type " + (value ? "select" : "")}>
                        <i className="icon-blank" />
                        {
                            text && <span>{text}</span>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default BsyRadioBox;